module.exports = __webpack_public_path__ + "img/Mask group@2x (4).89fd8d86.png";